import LabradorTrendingMenu, { StandaloneTrendingMenu, StandaloneTrendingMenuProps } from '@/components/TrendingMenu';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

const AllasStandaloneTrendingMenu: StandaloneComponent<StandaloneTrendingMenuProps> = (props) => (
  <StandaloneTrendingMenu {...mergeProps({ options: { $tag: { size: 'medium' } } }, props)} />
);

export const standalone = AllasStandaloneTrendingMenu;

export default LabradorTrendingMenu;
